/* eslint-disable react/prop-types */
import { Flex } from "@chakra-ui/react";

import { useTranslation } from "react-i18next";
import React, { useEffect } from "react";
import { useMutation } from "react-query";
import { Redirect, useHistory } from "react-router-dom";
import { availApiClient } from "../../apiConfig";
import Loader from "../../common/Loader";

import { _basePath } from "../../config";
import { useLock, UserContext, useUser } from "../../context";
import { useApiTenant } from "../../context/ApiAuthContext";
import ErrorMsg from "../../common/ErrorMsg";

const ConfirmAppointment = () => {
  const { loggedIn } = useUser();
  const { tenantId } = useApiTenant();
  const { t } = useTranslation();
  const history = useHistory();
  const { lock } = useLock();
  const { userData } = React.useContext(UserContext);

  const { mutate, isLoading, isError, error } = useMutation(
    (upgradeReq) =>
      availApiClient.userApiAvailabilitySchedulePost(
        tenantId,
        "1.0",
        "en-US,en",
        upgradeReq
      ),
    {
      onSuccess: () => {
        history.push(`${_basePath}/appointment/complete`);
      },
      onError: (err) => {
        if (err?.response?.data?.errors) {
          console.log(err?.response?.data);
        } else {
          console.log(err);
        }
      },
    }
  );

  const confirmSchedule = () => {
    const getRuleValidations = () => {
      if (userData?.rulesToken && userData?.requirementTypeId) {
        return [
          {
            rulesToken: userData?.rulesToken,
            requirementTypeId: userData?.requirementTypeId,
          },
        ];
      } else {
        return null;
      }
    };
    const upgradeReq = {
      scheduleId: userData?.lock?.scheduleId,
      rulesValidations: getRuleValidations(),
    };
    mutate(upgradeReq);
  };

  useEffect(() => {
    confirmSchedule();
  }, []);

  if (!lock) {
    return null;
  }
  if (!loggedIn) {
    return <Redirect to={_basePath} />;
  }

  if (isLoading) {
    return (
      <Flex w={"full"} h={"full"}>
        <Loader
          text={t("loader.scheduling_appointment", "Scheduling appointment...")}
        />
      </Flex>
    );
  }
  if (isError) {
    return (
      <Flex w={"full"} h={"full"} direction={"column"} alignItems={"center"}>
        <ErrorMsg
          message={t(
            "unable_to_schedule",
            "Unable to schedule your appointment at this time, please see a Staff member for more information."
          )}
        />
      </Flex>
    );
  }
  return <Redirect to={`${_basePath}/appointment/complete`} />;
};

export default ConfirmAppointment;
